import './Chip.scoped.scss'

export default function Chip({...props}) {
  return <div className="chip">
    {props.children}
  </div>
}

